module.exports = __webpack_public_path__ + "img/footer__append.36ca231f.png";